function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React, { useCallback, useContext, useLayoutEffect } from 'react';
import { Box, Progress, Text, VStack } from 'native-base';
import Footer from '../../../components/AuthenticatedLeadForms/Footer';
import { NavigationContext } from '../../../contexts';
import ReviewInformationBox from './ReviewInformationBox';
import { ContactInformationSchema } from '../../../utils';
import { FormatWithMask, mobileMask } from '../../MaskedInput';
const ReviewInformation = _ref => {
  let {
    metadata: {
      reviewInformationList
    },
    onNext,
    navigation,
    title,
    navigation: {
      current
    },
    id
  } = _ref;
  const FOOTER_NOTES = `By clicking “Submit”, you consent to be contacted, including via automated technology or artificial/prerecorded voice, by Freedom Mortgage and any of its current or future affiliated companies (collectively “Freedom Mortgage”) at the phone number(s) and email address provided for marketing purposes. You affirm that you are the subscriber of the phone number(s) and email address or that the subscriber has authorized you to provide this consent. Your consent is not a condition of purchase of goods or services from Freedom Mortgage. You can revoke your consent at any time by contacting Freedom Mortgage at 855-690-5900.`;
  const {
    total,
    review,
    setStep,
    step
  } = useContext(NavigationContext);
  const renderPreview = useCallback(item => /*#__PURE__*/React.createElement(ReviewInformationBox, _extends({}, item, {
    navigation: navigation,
    key: item.title
  })), [navigation]);
  const handleValidations = useCallback(async () => {
    const contactInfoStep = step + 1;
    let {
      firstName,
      lastName,
      email,
      phoneNumber,
      address: {
        street,
        street2,
        city,
        state,
        zipCode
      }
    } = review[contactInfoStep];
    phoneNumber = FormatWithMask({
      mask: mobileMask,
      text: phoneNumber
    }).unmasked;
    try {
      await ContactInformationSchema.validate({
        firstName,
        lastName,
        email,
        phoneNumber,
        street,
        street2,
        city,
        state,
        zipCode
      }, {
        abortEarly: false
      });
    } catch (e) {
      setStep(contactInfoStep);
    }
  }, [review, setStep, step]);
  useLayoutEffect(() => {
    handleValidations().catch(console.log);
  }, [handleValidations]);
  return /*#__PURE__*/React.createElement(Box, {
    key: "review-information"
  }, /*#__PURE__*/React.createElement(Text, {
    fontSize: {
      base: '4xl',
      lg: '46'
    },
    fontWeight: 'light',
    accessibilityLabel: title,
    accessibilityRole: "text",
    testID: `radio-card-group-${title}`,
    mb: "5"
  }, title), total !== 1 ? /*#__PURE__*/React.createElement(VStack, {
    space: 1,
    w: "100%"
  }, /*#__PURE__*/React.createElement(Progress, {
    value: Math.ceil(100 / total * current),
    h: "2",
    bg: "white.700",
    borderColor: "#979797",
    borderWidth: "0.25",
    _filledTrack: {
      bg: {
        linearGradient: {
          colors: ['#8C98A3', '#1B68A5'],
          start: [0, 0],
          end: [1, 0]
        }
      }
    }
  }), /*#__PURE__*/React.createElement(Text, {
    textAlign: "right",
    fontFamily: "body",
    fontWeight: "medium",
    fontSize: "sm",
    color: "navyblue.500"
  }, `${current}/${total}`)) : null, /*#__PURE__*/React.createElement(Box, {
    width: "100%",
    key: id
  }, reviewInformationList.map(renderPreview)), /*#__PURE__*/React.createElement(Text, {
    fontSize: "md"
  }, FOOTER_NOTES), /*#__PURE__*/React.createElement(Footer, {
    onNext: onNext,
    navigation: navigation,
    isLastScreen: true,
    selectedValue: "0"
  }));
};
export default /*#__PURE__*/React.memo(ReviewInformation);
//# sourceMappingURL=index.js.map